export default __webpack_public_path__ + "static/media/jake-pencil.49f4759c.mp4";